import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalStorage } from 'src/app/appCommon/Enums/enum';
import { AnalyzeService } from 'src/app/appServices/AnalyzeService/analyzeService.service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ObservableService } from 'src/app/appServices/ObservableService/observable.service';
import { environment } from 'src/environments/environment';
import { trigger,state,style,transition,animate } from '@angular/animations';
import { DatePipe } from '@angular/common';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
const AUTH_API = environment.teleUrl;

@Component({
  selector: 'app-counter-measures',
  templateUrl: './counter-measures.component.html',
  styleUrls: ['./counter-measures.component.scss'],
  animations: [
    trigger('rowExpansionTrigger', [
        state('void', style({
            transform: 'translateX(-10%)',
            opacity: 0
        })),
        state('active', style({
            transform: 'translateX(0)',
            opacity: 1
        })),
        transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
]
})
export class CounterMeasuresComponent implements OnInit{
  loader: any;
  @ViewChild('dt') dt: Table | undefined;
  UId: any;
  RoleName: any;
  lazyLoadSearchBool: boolean = false;
  accessCase: string=`${AUTH_API}Case/Edit/`;
  showPopupOnLoad:string = `?showPopupOnLoad=true`;
  proposed_date_array:any = [];
  excel_chartDisabe: any;
  
  constructor(public analyzeService: AnalyzeService,private helperService: HelperService,
    private Observable:ObservableService) { }
  
  counterMeasuresData: any;
  totalRecords = 0;
  pageNumber = 1;
  rows = 10;
  sortOrder = "ASC";
  sortCol = "";
  filterVal = "";
  cols: any;
  displayCounterMeasures = false;
  CounterMeasuresIndexData: any;
  C_measure_rootId: any = '';
  SpecificCounterMeasure: any =[];
  case_number: any;
  root_id: any = '';
  showProgressSpinner:boolean = false;
  datePipe = new DatePipe('en-US');
  orderPinckCaseList:any = [];
  private subscription: Subscription[] = [];
  ngOnInit(): void {
    this.UId = this.helperService.decryption(localStorage.getItem(LocalStorage.UId));
    this.RoleName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserRoleName));
    this.analyzeService._facilityPiComponent.CounterMeasuresComponent = this;
    if((this.analyzeService._facilityPiRecord.CounterMeasuresRecord != null) && ( this.analyzeService._facilityPiRecord.CounterMeasuresRecord != undefined)){
      this.counterMeasuresData = this.analyzeService._facilityPiRecord.CounterMeasuresRecord;
    }
    
    if(this.analyzeService._facilityPiRecord.CounterMeasuresRecord == undefined){
      if(this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj != undefined){
      this.analyzeService._facilityPiComponent.FacilityPIComponent.getFacilityDashboardValues();
      this.lazyLoadSearchBool = true;
      }
    }else{
      this.lazyLoadSearchBool = false;
    }
    
  }
  ngAfterContentInit(): void {
    if(this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj != undefined){
      this.Observable.value$.subscribe((val) => {
        // this.showProgressSpinner = val;
      });
}
  }

  GetCounterMeasures(excel_chartDisabe: any,loader: any) {
    this.showProgressSpinner = true;
    this.totalRecords = 0;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.searchString = this.filterVal;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Filter.value = this.filterVal;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Sort.FieldName = this.sortCol;
    this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Sort.Order = this.sortOrder;
    this.subscription.push(
    this.analyzeService.GetCounterMeasures(this.RoleName,this.UId,this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj).subscribe({
      next: (res: any) => {
        this.showProgressSpinner = false;
        this.counterMeasuresData = res.data;
        this.proposed_date_array = [];
        this.counterMeasuresData.forEach((c:any,indx:any)=>{
          if(c.DateOfService){
            c.DateOfService = this.datePipe.transform(c.DateOfService, 'dd/MM/yyyy');
          }
          if(c._objCounterMeasures.length > 0){
            c._objCounterMeasures.forEach((o:any)=>{
              if(o.rca_proposed_due_date != null && o.rca_proposed_due_date != ""){
                const formatedDate = new Date(o.rca_proposed_due_date)
                o.rca_proposed_due_date = this.datePipe.transform(formatedDate, 'dd/MM/yyyy');
                let currentDate:any =  new Date();
                
                if( o.rca_completed_date == null && formatedDate < currentDate){
                  this.proposed_date_array.push({date:o.rca_proposed_due_date,rootCause:o.rca_root_cause});
                }
              }
            })
          
          let fromIndex:any;
          let element: any;
          let counterMeasuresList: any;
          if(this.proposed_date_array.length > 0){
              const sortedActivities = this.proposed_date_array.sort((a:any, b:any) => new Date(b.date).getTime() - new Date(a.date).getTime());
              sortedActivities.forEach((item:any)=>{
                fromIndex= c._objCounterMeasures.findIndex((num:any)=>num.rca_proposed_due_date === item.date && num.rca_completed_date == null && num.rca_root_cause == item.rootCause);

                if(fromIndex != 0 && fromIndex != -1){
                  element = c._objCounterMeasures.splice(fromIndex, 1)[0];
                  element.status = true;
                  c._objCounterMeasures.unshift(element);
                }
                if(fromIndex == 0){
                  c._objCounterMeasures[0].status = true;
                }
              });
              
              counterMeasuresList = this.counterMeasuresData.splice(indx, 1)[0];
              this.counterMeasuresData.unshift(counterMeasuresList);
              this.proposed_date_array = [];
          }
            }
        })

        this.counterMeasuresData = this.counterMeasuresData.sort((a:any, b:any) =>  !a._objCounterMeasures[0]?.rca_proposed_due_date ? 1 : !b._objCounterMeasures[0]?.rca_proposed_due_date ? 1 :  Number(new Date(a._objCounterMeasures[0]?.rca_proposed_due_date)) - Number(new Date(b._objCounterMeasures[0]?.rca_proposed_due_date)))
        
        this.analyzeService._facilityPiRecord.CounterMeasuresRecord =  this.counterMeasuresData;
        this.totalRecords = res.Total;
        this.analyzeService.currentDateTime();
        loader.value = false;
        excel_chartDisabe.value = false;
      },
    })
    );
  }

  fDate(s:any){
    let d = new Date();
        s = s.split('/');
        d.setFullYear(s[2]);
        d.setMonth(s[1]);
        d.setDate(s[0]);
        return d;
  }

  counterMeasures(rootId: any) {
    this.displayCounterMeasures = true;
  }

  GetCounterMeasureModal(caseNumber: any, rootId: any){
    this.case_number = caseNumber;
    this.root_id = rootId;
    this.subscription.push(
    this.analyzeService.GetCounterMeasureModal(this.root_id).subscribe({
      next: (res: any) => {
        this.SpecificCounterMeasure = res.data;
      }
    })
    );
  }

  lazyLoadSchedules(event: any) {
    if (event != undefined) {
      this.rows = event.rows;
      this.pageNumber = event.first / this.rows + 1;
      this.sortOrder =
        event.multiSortMeta == undefined || event.multiSortMeta[0].order == -1
          ? 'DESC'
          : 'ASC';
      this.sortCol =
        event.multiSortMeta == undefined
          ? 'FacilityName'
          : event.multiSortMeta[0].field;
      this.filterVal =
        event.filters.global == undefined ? '' : event.filters.global.value;
      if (this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj != undefined) {
        this.excel_chartDisabe = { 'value': true, 'excel_show': true, 'facility_charts_Show': false, 'pi_chart_show': false };
        this.loader = { 'value': true };
        this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.PageNumber = this.pageNumber;
        this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Take = this.rows;
        this.analyzeService._facilityPiFilterObj.CounterMeasuresDataObj.Skip = this.rows * this.pageNumber - this.rows;
        if (this.rows != 10 || this.pageNumber != 1 || event.multiSortMeta != undefined) {
          this.lazyLoadSearchBool = false;
        }
        if (this.lazyLoadSearchBool == false) {
          this.GetCounterMeasures(this.excel_chartDisabe, this.loader);
        }
      }
    }
  }

  applyFilterGlobal($event: any, stringVal: any) {
    this.dt!.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  ngOnDestroy() {
    if(this.subscription.length != 0){
      this.subscription.forEach((i:any)=>{
        i.unsubscribe();
      })
    }
     Object.getOwnPropertyNames(this)
      .filter(propName => Array.isArray((<any>this)[propName]))
      .forEach(propName => (<any>this)[propName] = []);
     
     }
}
